export default __webpack_public_path__ + "static/media/pierre-baillargeon.97a12d34.jpg";